// extracted by mini-css-extract-plugin
export default {"main_container":"ResultsHeader_main_container__yB2A-"};